<template>
  <v-app>
    <navBar />
    <slider />
    <!-- <bodyhome style="margin-top: 0%;"/> -->
    <bodyhome2 />
    <foot />
  </v-app>
</template>
<script>
import navBar from "@/components/navbar";
import foot from "@/components/footer";
import slider from "@/components/home_page_components/slider_home";
import bodyhome from "@/components/home_page_components/body_home";
import bodyhome2 from "@/components/home_page_components/bodyhome2";
export default {
  components: { navBar, slider, bodyhome, foot, bodyhome2 }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/homepage.vue